import { useEffect, useState } from 'react'
// eslint-disable-next-line
import axios from 'axios'

export function useAuth( id ) {
  const [authUser, setAuthUser] = useState( "" )
  const [similarArtists, setSimilarArtist] = useState( [] )
  const HOST = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_BASEURL : 'http://localhost:4000'
  const phone = process.env.REACT_APP_PHONE
  const password = process.env.REACT_APP_PASS
  const currentTime = new Date
  const timestamp = currentTime.getTime()
  // let cookieToken = process.env.Cookie
  // console.log( "cookie", cookieToken )

  /** Instead of running the login function everytime, run login status instead. If logged in, get cookie and continue on simi-artists
  // Plus this function should only run when on Artists Page and not from the beginning.    url: `${HOST}/login/status`, method: 'GET'  

// Neteasecloud's official doc
  const { login_cellphone, user_cloud } = require('NeteaseCloudMusicApi')
  const phone = '' // 这里填手机号
  const password = '' // 这里填密码
  const fileUpdateTime = {}
  if (!phone || !password) {
    const msg = '请设置你的手机号码和密码'
    alert(msg)
    throw new Error(msg)
  }

  async function login() {
    const res = await axios({
      url: `/login/cellphone`,
      method: 'post',
      data: {
        phone: phone,
        password: password,
      },
    })
    return res.data.cookie
  }
  async function main() {
    const cookieToken = await login()
    const res = await axios({
      url: `/login/status`,
      method: 'post',
      data: {
        cookie: cookieToken,
      },
    })
  }
  main()    **/

  /** const phone = '' // 这里填手机号
  const password = '' // 这里填密码
  const fileUpdateTime = {}
  let cookieToken = ''
  if (!phone || !password) {
    const msg = '请设置你的手机号码和密码'
    alert(msg)
    throw new Error(msg)
  }

  async function login() {
    const res = await axios({
      url: `/login/cellphone?phone=${phone}&password=${encodeURIComponent(
        password,
      )}`,
    })
    cookieToken = res.data.cookie
  }
  async function main() {
    await login()
    const res = await axios({
      url: `/homepage/block/page`,
      data: {
        cookie: cookieToken,
      },
      method: 'post',
    })
    let cursor = ''
    console.log(res.data.data)
    if (res.data.data.hasMore) {
      cursor = res.data.data.cursor
      const res2 = await axios({
        url: `/homepage/block/page?time=${Date.now()}`,
        data: {
          cookie: cookieToken,
          cursor: cursor,
        },
        method: 'post',
      })
    }
  }
  main() */

  /**
   const httpHeader = { "Content-Type": "application/json;charset=utf-8" };
   const networkError = {
  errmsg: "请求失败,请检查网络配置",
  fail: true,
};

  const mobileLogin = async ( phone: string, password: string ) => {
    try {
      const res = await fetch( `${BaseUrl}/login/cellphone`, {
        method: "POST",
        body: JSON.stringify( { phone: phone, password: password } ),
        credentials: "include",
        headers: httpHeader,
      } );
      const data = await res.json();
      return data;
    } catch ( error ) {
      return networkError;
    }
  };
**/
  useEffect( () => {
    const checkUserStatus = async () => {
      await axios( {
        // url: `${HOST}/login/cellphone?phone=${phone}&password=${encodeURIComponent( password )}&timestamp=${timestamp}`,
        // method: 'POST',
        // withCredentials: true //essential
        // xhrFields: {
        //     withCredentials: true
        // },
        url: `${HOST}/login/status`,
        method: 'GET',
        xhrFields: {
          withCredentials: true
        },
      } )
        .then( function ( res ) {
          // console.log( res, "user res" )
          if ( res.status === 200 && id !== undefined ) {
            setAuthUser( res.data )
            axios( {
              method: 'GET',
              url: `${HOST}/simi/artist?id=${id}`,
              _xhrFields: {
                withCredentials: true
              },
            } )
              .then( function ( res ) {
                setSimilarArtist( res?.data?.artists )
              } )
              .catch( function ( error ) {
                console.log( "Similar artists Error: " + " " + error )
              } )
          } else {
            console.log( 'Login Required' )
            setAuthUser( "" )
            setSimilarArtist( [] )
            return
          }
        } )
    }
    checkUserStatus()
  }, [id] )

  useEffect( () => {

  }, [] )

  function checkLoginStatus() {
    const res = axios( {
      url: `${HOST}/login/status`,
      method: 'GET',
      xhrFields: {
        withCredentials: true
      },
    } )
      .then( function ( res ) {
        console.log( res, "loginStatus res" )
        if ( res.status === 200 ) { //Here run the if OK, then get similar artists else run the automatic login function, get the cookie and get similar artists 
          console.log( "ALL GOOD " )
        } else {
          console.log( "ERROR ERROR ERROR" )
        }
      } )
      .catch( function ( error ) {
        console.log( "Error: ", error )
      } )
    // return res
    // return cookieToken
  }

  return [{
    authUser,
    similarArtists,
  }]
}